(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fi-sibling-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fi-sibling-swatches')) {
    customElements.define(
      'fi-sibling-swatches',
      class extends HTMLElement {
        connectedCallback() {
          if (this._ac) return;
          this._ac = new AbortController();
          const value = this.querySelector('.fi-sib__value');
          if (!value) return;
          const set = (e) => {
            const a = e.target.closest && e.target.closest('.fi-sib__swatch');
            if (a) value.textContent = a.dataset.label || '';
          };
          const reset = () => {
            value.textContent = value.dataset.current || '';
          };
          const opts = { signal: this._ac.signal };
          this.addEventListener('pointerover', set, opts);
          this.addEventListener('focusin', set, opts);
          this.addEventListener('pointerleave', reset, opts);
          this.addEventListener('focusout', reset, opts);
        }
        disconnectedCallback() {
          if (this._ac) this._ac.abort();
          this._ac = null;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
